import React, { useEffect, useRef } from 'react';
import PageContainer from '../../components/PageContainer';
import MainContent from '../../components/MainContent';
import PageTitle from '../../components/Common/PageTitle/PageTitle';
import ActivityLoader from '../../components/Common/ActivityLoader';
import Notification from '../../components/Common/Notification';
import Pagination from '../../components/Common/Pagination';
import ActionDropdownItem from '../../components/Common/PageTitle/ActionDropdownItem';
import printContent from '../../util/araknerdlib';
import { useStudent } from '../../DataStore/StudentContext';
import functions from '../../util/functions';
import { useNavigate } from 'react-router-dom';
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import StudentListFilter from '../../components/Student/StudentListFilter';

const StudentListingPage = () => {
    const { listing, metaData, setCurrentPage, getStudents, mounted, loadProfile } = useStudent();
    const reportRef = useRef();

    useEffect(() => {
        if(!mounted){
            getStudents();
        }
    }, []);

     const goToStudentProfile = (profileInfo)=>{
        loadProfile(profileInfo.id);
        navigate('/student-profile');
    }

    const navigate = useNavigate();

    const PageActions = () => (
        <>
            <ActionDropdownItem iconClass="fa fa-sync text-primary" label="Refresh" onClick={() => getStudents(true)} />
            <ActionDropdownItem iconClass="fa fa-print text-secondary" label="Print" onClick={() => printContent(reportRef, "Class List")} />
            <ActionDropdownItem iconClass="fa fa-file-excel text-success" label="Export" onClick={handleExport} />
        </>
    );

    const handleExport = () => {
        if (!listing || listing.length === 0) {
            return;
        }

        const worksheet = XLSX.utils.json_to_sheet(listing.map(student => ({
            "Reg. No": student.reg_no,
            "Full Name": student.full_name,
            "Gender": student.sex,
            "Class": student.class?.class_name || '-',
            "Stream": student.stream?.stream_name || '-',
            "Level": student.class?.level?.level_name || '-',
            "Residence": student.residence?.residence_name || '-',
            "Status": student.status_name,
            "Admission Date": student.admission_date ? functions.formatDate(student.admission_date) : ''
        })));

        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "Students");

        const excelBuffer = XLSX.write(workbook, { bookType: "xlsx", type: "array" });
        const data = new Blob([excelBuffer], { type: "application/octet-stream" });
        saveAs(data, "Student_List.xlsx");
    };

    return (
        <PageContainer>
            <MainContent>
                <PageTitle
                    title="Manage Students"
                    description="View and manage students"
                    iconClass="fa fa-users"
                    sticky={true}
                    PageActions={PageActions}
                    Pagination={metaData ? (
                        <Pagination
                            metaData={metaData}
                            onPageChange={(page) => setCurrentPage(page)}
                            loadMore={true}
                        />
                    ) : null}
                />

                <div>
                    <div className="card mb-4">
                        <StudentListFilter handleExport={handleExport} />
                        <div className="card-body">
                            <div className="table-responsive" ref={reportRef}>
                            {Array.isArray(listing) ? (
                                <table className="table table-striped table-bordered" style={{fontSize: '12px'}}>
                                    <thead className="thead-light">
                                        <tr>
                                            <th>#</th>
                                            <th>Reg. No</th>
                                            <th>Full Name</th>
                                            <th>Gender</th>
                                            <th>Class</th>
                                            <th>Stream</th>
                                            <th>Level</th>
                                            <th>Residence</th>
                                            <th>Status</th>
                                            <th>Admission Date</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {listing.map((student, index) => (
                                            <tr key={student.id}>
                                                <td>{index + 1}</td>
                                                <td>{student.reg_no}</td>
                                                <td><span className='link text-primary' onClick={()=>goToStudentProfile(student)}>{student.full_name.toUpperCase()}</span></td>
                                                <td>{student.sex.toUpperCase()}</td>
                                                <td>{student.class?.class_name || '-'}</td>
                                                <td>{student.stream?.stream_name || '-'}</td>
                                                <td>{student.class?.level?.level_name || '-'}</td>
                                                <td>{student.residence?.residence_name || '-'}</td>
                                                <td>{student.status_name}</td>
                                                <td>{student.admission_date ? functions.formatDate(student.admission_date) : ''}</td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            ) : listing === '404' ? (
                                <Notification type="info" message="No students found." closable={false} />
                            ) : (
                                <ActivityLoader />
                            )}
                        </div>
                     </div>
                    </div>
                </div>
            </MainContent>
        </PageContainer>
    );
};

export default StudentListingPage;
